// components imports
import ButtonComp from "./ButtonComp";
import GAlign from "./GAlign";
// library imports
import { Col, Container, Row } from "react-bootstrap";
// data imports
import { data } from "../Data/data";
import { Link } from "react-router-dom";
import Typography from "./Typography/Typography";
import Animation from "../animations/Animation";

const Choose = () => {
   return (
      <>
         <section className="choose-us pt80 pb80 pb-xxl-60 mobPt50 mobPb50">
            <Container>
               <Row className="gx-4">
                  <Col lg={9} md={8} sm={12} xs={12}>
                     <Animation fade bottom>
                        <>
                           <span className="red-bar">WHY CHOOSE US</span>
                           <span className="d-block fBold font-60 font-sm-32 mb-md-3 mb-sm-0">What Makes Us Different?</span>
                        </>
                     </Animation>
                  </Col>
                  <Col lg={3} md={4} className="dNoneXs">
                     <Animation fade bottom>
                        <div className="mt40 ml0 d-flex justify-content-end">
                           <Link to="/get-in-touch">
                              <ButtonComp title="GET IN TOUCH" />
                           </Link>
                        </div>
                     </Animation>
                  </Col>
               </Row>
               <Row className="mt30 mobMt10">
                  {data.chooseUs.map((elem) => {
                     return (
                        <Col lg={3} md={6} sm={12} xs={12} key={elem.id} className="choose-us-features mobMt20 mobMb20">
                           <Animation fade bottom>
                              <section>
                                 <GAlign align="between" alignv="center" className="mb10">
                                    <Typography element="h6" className="fs16" syne fontWeight={700}>
                                       0{elem.id}
                                    </Typography>
                                    <Typography element="h6" className="mobMl10 fs16" syne fontWeight={700}>
                                       {elem.title}
                                    </Typography>
                                 </GAlign>
                                 <div>
                                    <img src={elem.img} alt={elem.title} className="w-100 mb15 chooseimg" />
                                 </div>
                                 <Typography element="p" DMSans className="colorGrey font-14 lh28 font12">
                                    {elem.description}
                                 </Typography>
                              </section>
                           </Animation>
                        </Col>
                     );
                  })}
                  <Col lg={3} md={3} className="mobDflex dNoneNonMob">
                     <div className="mt60 mobMt10 ml0">
                        <Link to="/get-in-touch">
                           <ButtonComp title="GET IN TOUCH" />
                        </Link>
                     </div>
                  </Col>
               </Row>
            </Container>
         </section>
      </>
   );
};

export default Choose;
